export const MAIL_RAW_MAX_BYTES = 50 * 1024 * 1024;
export const MAIL_PART_MAX_BYTES = 20 * 1024 * 1024;
export const MAIL_DECODED_MAX_BYTES = 50 * 1024 * 1024;
export const MAIL_BODY_MAX_BYTES = 2 * 1024 * 1024;
export const MAIL_HEADER_MAX_BYTES = 64 * 1024;
export const MAIL_MAX_PARTS = 100;
export const MAIL_MAX_PARTICIPANTS = 500;
export const MAIL_MAX_SUBJECT_CHARACTERS = 998;
export const MAIL_PARSE_TIMEOUT_MS = 30_000;
export const MAIL_SOURCE_IDENTITY_VERSION = 1;
export const MAIL_THREAD_MAX_MESSAGES = 100;
export const MAIL_SYNC_UID_PAGE_SIZE = 1_000;
export const MAIL_SYNC_BATCH_BUDGET = 20;
export const MAIL_SYNC_MAX_BATCH_BUDGET = 200;
export const MAIL_SYNC_MAX_ATTEMPTS = 3;
export const MAIL_SYNC_LEASE_MS = 120_000;
export const MAIL_SYNC_INTERVAL_MS = 5 * 60_000;
export const MAIL_SYNC_RECOVERY_INTERVAL_MS = 30_000;
export const MAIL_SYNC_MAX_FOLDERS = 1_000;
export const MAIL_SYNC_MAX_ISSUES_PER_FOLDER = 100;
export const MAIL_SYNC_DISCOVERY_BATCH_SIZE = 25;
export const MAIL_SYNC_RETRY_BASE_MS = 5_000;
export const MAIL_SOURCE_FINDINGS = [
    'IDENTITY_INSUFFICIENT',
    'DATE_INVALID_OR_MISSING',
    'ADDRESS_INVALID',
    'SENDER_MULTIPLE_OR_MISSING',
    'HEADER_DUPLICATE',
    'ATTACHMENT_BLOCKED',
    'BODY_TRUNCATED',
    'BODY_CONVERSION_FAILED',
    'MESSAGE_ID_COLLISION',
    'MESSAGE_ID_INVALID',
    'PROVIDER_ID_COLLISION',
];
export const MAIL_ATTACHMENT_BLOCK_REASONS = [
    'UNSUPPORTED_TYPE',
    'SIZE_LIMIT',
    'INVALID_FILE',
];
export const MAIL_MATCH_RULE_VERSION = 1;
export const MAIL_MATCH_MAX_CANDIDATES = 1_000;
export const MAIL_REMATCH_MAX_SOURCES = 100;
export const MAIL_REMATCH_PREVIEW_TTL_MS = 15 * 60_000;
//# sourceMappingURL=mail.js.map